module.exports = __webpack_public_path__ + "static/media/horarios_icon.1eaab2de.svg";